(() => {
  // The menu is a drawer at every screen size, so the desktop hover-dropdown mode is switched off.
  const desktop = window.matchMedia('not all');
  const canHover = window.matchMedia('(hover: hover)');
  const root = document.documentElement;

  function groups() { return document.querySelectorAll('[data-nav-group]'); }
  function closeGroups(except) { groups().forEach(d => { if (d !== except) d.open = false; }); }

  function openDrawer() {
    const nav = document.querySelector('[data-site-nav]');
    if (!nav) return;
    root.classList.add('nav-open');
    document.querySelectorAll('.nav-backdrop').forEach(b => b.hidden = false);
    document.querySelectorAll('[data-nav-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const close = nav.querySelector('.nav-close');
    if (close) close.focus();
  }
  function closeDrawer(returnFocus) {
    if (!root.classList.contains('nav-open')) return;
    root.classList.remove('nav-open');
    document.querySelectorAll('.nav-backdrop').forEach(b => b.hidden = true);
    document.querySelectorAll('[data-nav-open]').forEach(b => {
      b.setAttribute('aria-expanded', 'false');
      if (returnFocus) b.focus();
    });
  }

  document.addEventListener('click', e => {
    if (e.target.closest('[data-nav-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-nav-close]')) { closeDrawer(true); return; }

    const colToggle = e.target.closest('.nav-col-toggle');
    if (colToggle) {
      const col = colToggle.closest('[data-nav-col]');
      const open = !col.classList.contains('is-open');
      col.classList.toggle('is-open', open);
      colToggle.setAttribute('aria-expanded', String(open));
      return;
    }

    const summary = e.target.closest('[data-nav-group] > summary');
    if (summary && desktop.matches) {
      const d = summary.parentElement;
      // Already opened by hover: a mouse click shouldn't collapse it
      if (d.open && canHover.matches && e.detail > 0 && d.closest('.nav-item').matches(':hover')) { e.preventDefault(); return; }
      if (!d.open) closeGroups(d);
      return;
    }

    if (!e.target.closest('[data-nav-group]') && desktop.matches) closeGroups();
  });

  // Desktop: open on hover, close when the pointer leaves
  document.addEventListener('pointerover', e => {
    if (e.pointerType !== 'mouse' || !desktop.matches || !canHover.matches) return;
    const item = e.target.closest('.nav-item.has-panel');
    if (!item) return;
    const d = item.querySelector('[data-nav-group]');
    clearTimeout(item._navTimer);
    if (!d.open) { closeGroups(d); d.open = true; }
  });
  document.addEventListener('pointerout', e => {
    if (e.pointerType !== 'mouse' || !desktop.matches || !canHover.matches) return;
    const item = e.target.closest('.nav-item.has-panel');
    if (!item || item.contains(e.relatedTarget)) return;
    const d = item.querySelector('[data-nav-group]');
    item._navTimer = setTimeout(() => { d.open = false; }, 180);
  });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (root.classList.contains('nav-open')) { closeDrawer(true); return; }
    const openGroup = document.querySelector('[data-nav-group][open]');
    if (openGroup) { openGroup.open = false; openGroup.querySelector('summary').focus(); }
  });

  desktop.addEventListener('change', () => { closeDrawer(false); closeGroups(); });
})();
